import Highway from "@dogstudio/highway";
import CustomPlayer from "../modules/video";

export default class PageOrders extends Highway.Renderer {
  onEnter() {
    this.DOM = { view: this.wrap.lastElementChild };
    this.DOM.header = document.querySelector(".Header");
    this.DOM.videoPlay = this.DOM.view.querySelector(".video__container");
    this.DOM.video = this.DOM.view.querySelector(
      ".video__popup #youtube_video"
    );

    this.DOM.header.classList.add("is--dark");

    console.log("page orders loaded");

    this.initVideo();
  }

  initVideo() {
    const { videoPlay, video } = this.DOM;

    if (video) this.player = new CustomPlayer(videoPlay, video);
  }

  onLeaveCompleted() {
    this.DOM.header.classList.remove("is--dark");

    if (this.player) {
      this.player.destroy();
    }
  }
}
